/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询剧院新闻聚焦信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetTheaterNewsParams {
  constructor(public typeId: string) {}
}

export default async function (
  params: GetTheaterNewsParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.TheaterNewsDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater/news-notice`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
